import Cookies from 'js-cookie'
const TokenKey = 'access_token'
const RefreshTokenKey = 'refresh_token'
const Member = 'member'
const BetRatio = 'BetRatio'
const TenantId = 'tenantId'
const Lang = 'Lang'
const Secret = 'secret'
const Type = 'type'
const App = 'isFromApp'

export function setAPP () {
  Cookies.set(App, 1)
}
export function isAPP () {
  return Cookies.get(App)
}
export function removeAPP () {
  return Cookies.remove(App)
}
export function LogOut () {
  removeToken()
}
export function Login (res) {
  let result = res
  result.isLogin = 1
  Cookies.set(Member, JSON.stringify(result))
  Cookies.set(TokenKey, result.access_token)
  Cookies.set(RefreshTokenKey, result.refresh_token)

  // Cookies.set('expires_in', res.expires_in)
  // Cookies.set('scope', res.scope)
  // Cookies.set('tenant_id', res.tenant_id)
  // Cookies.set('user_id', res.user_id)
  // Cookies.set('user_name', res.user_name)
  // access_token，refresh_token，expires_in，scope，tenant_id，user_id，user_name
}
export function setGameBetRatio (data) {
  Cookies.set(BetRatio, data)
}
export function getGameBetRatio (gameBetRatio) {
  return Cookies.get(BetRatio)
}
export function setSecret (value) {
  console.log(value)
  return Cookies.set(Secret, value)
}
export function getSecret () {
  return Cookies.get(Secret)
}
export function setType (value) {
  return Cookies.set(Type, value)
}
export function getType () {
  return Cookies.get(Type)
}
export function setLang (value) {
  return Cookies.set(Lang, value)
}
export function getLang () {
  return Cookies.get(Lang)
}
export function isLogin () {
  let _member = Cookies.get(Member)
  if (_member) {
    let member = JSON.parse(Cookies.get(Member))
    if (member.isLogin === 1) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}
export function getMember () {
  let res = Cookies.get(Member)
  if (res) {
    let data = JSON.parse(Cookies.get(Member))
    return data
  } else {
    LogOut()
  }
}
export function setTenantId (value) {
  console.log(value)
  return Cookies.set(TenantId, value)
}
export function getTenantId () {
  return Cookies.get(TenantId)
}
export function removeTenantId (value) {
  return Cookies.remove(TenantId)
}
export function getToken () {
  return Cookies.get(TokenKey)
}
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}
export function getRefreshToken () {
  return Cookies.get(RefreshTokenKey)
}
export function setRefreshToken (token) {
  return Cookies.set(RefreshTokenKey, token)
}
export function removeToken () {
  Cookies.remove(TokenKey)
  Cookies.remove(RefreshTokenKey)
  Cookies.remove(Member)
  Cookies.remove(BetRatio)
  // Cookies.remove(TenantId)
}
export function removeRefreshToken () {
  return Cookies.remove(RefreshTokenKey)
}
export function getExpectedEarnings (type, amount) {
  // 180 seconds  30% Commissions
  // 120 seconds  40% Commissions
  // 90 seconds   50% Commissions
  // 60 seconds 60% Commissions
  amount = +amount
  switch (type) {
  case 1:
    return (amount + amount * 0.6)
  case 2:
    return (amount + amount * 0.5)
  case 3:
    return (amount + amount * 0.3)
  case 4:
    return (amount + amount * 0.2)
  }
}
export function float2 (number) {
  return Math.floor(number * 100) / 100
}



// WEBPACK FOOTER //
// ./src/utils/auth.js